import config from "./config/io";
import aerial from "./images/aerial.png";
import netzkarte from "./images/netzkarte.png";
import {
  AERIAL_LAYER_NAME,
  AERIAL_MAPSET_STYLE,
  BASE_LAYER_NAME,
  STYLE_REVIEW_PREFIX,
  TRAVIC_MAPSET_STYLE,
} from "./utils/constants";

import type { EnvStateByDomain } from "./envConfig";

const state: EnvStateByDomain = {
  app: {
    config: config as EnvStateByDomain["app"]["config"],
    defaultLang: "en",
    hideSbbCopyright: true,
    languageOptions: [
      { child: "Deutsch", id: "de", value: "de-DE" },
      { child: "Français", id: "fr", value: "fr" },
      { child: "Italiano", id: "it", value: "it" },
      { child: "English", id: "en", value: "en" },
    ],
    prefAgencies: "db",
    ssoClientId: "991094",
    useGeneralizedRouting: false,
  },
  map: {
    center: [949653.65, 6803851.06],
    defaultBaseLayers: [
      {
        key: "world.geops.travic",
        name: BASE_LAYER_NAME,
        style: `${STYLE_REVIEW_PREFIX}${TRAVIC_MAPSET_STYLE}`,
        thumbnail: netzkarte,
      },
      {
        key: "world.geops.aerial",
        name: AERIAL_LAYER_NAME,
        style: `${STYLE_REVIEW_PREFIX}${AERIAL_MAPSET_STYLE}`,
        thumbnail: aerial,
      },
    ],
  },
};
export default state;
